export const INVOICE_EDIT_UNSAVED_CHANGES_BlOCKER_ID = '';
